import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private data: Record<string | number, any> = {};

  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setData(id: string | number, data: any) {
    this.data[id] = data;
  }

  getData<T>(id: string | number): T | null {
    return this.data[id];
  }
}
